var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTextureFix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.914 7.168L21.4049 6.05715L20.294 5.548L21.404 5.044L21.914 3.928L22.424 5.044L23.534 5.548L22.4232 6.05715L21.914 7.168ZM18.254 4.696L18.8315 3.4255L20.102 2.848L18.8315 2.2705L18.254 1L17.6765 2.2705L16.406 2.848L17.6765 3.4255L18.254 4.696Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 22.8L4.15 21.15L5.8 20.4L4.15 19.65L3.4 18L2.65 19.65L1 20.4L2.65 21.15L3.4 22.8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61007 18.93C6.18657 18.93 5.82403 18.7792 5.52244 18.4776C5.22086 18.176 5.07007 17.8135 5.07007 17.39V6.61C5.07007 6.1865 5.22086 5.82396 5.52244 5.52237C5.82403 5.22079 6.18657 5.07 6.61007 5.07H17.3901C17.8136 5.07 18.1761 5.22079 18.4777 5.52237C18.7793 5.82396 18.9301 6.1865 18.9301 6.61V17.39C18.9301 17.8135 18.7793 18.176 18.4777 18.4776C18.1761 18.7792 17.8136 18.93 17.3901 18.93H6.61007ZM12.7701 12.77V17.39H17.3901V12.77H12.7701ZM12.7701 11.23H17.3901V6.61H12.7701V11.23ZM11.2301 11.23V6.61H6.61007V11.23H11.2301ZM11.2301 12.77H6.61007V17.39H11.2301V12.77Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTextureFix);
export default __webpack_public_path__ + "static/media/icon-texture-fix.4a081bc8ef6a3aa1bf3083670dc48387.svg";
export { ForwardRef as ReactComponent };